import type { Dispatch } from "redux";
import actions from "~/shared/actions/documents";
import * as server from "~/shared/api/server";
import type { SaveScrollPosition } from "~/shared/reducers/documents";

export function getNyeDokumenter() {
	return async (dispatch: Dispatch) => {
		dispatch(actions.dokumenterNyeRequest());
		const response = await server.getDokumenter();
		dispatch(actions.dokumenterNyeResponse(response));
	};
}

export function getGamleDocuments(flagHenterGamleDokumentene = true) {
	return async (dispatch: Dispatch) => {
		dispatch(actions.dokumenterGamleRequest(flagHenterGamleDokumentene));
		const response = await server.getGamleDokumenter();
		dispatch(actions.dokumenterGamleResponse(response));
	};
}

export function setLest(id: string) {
	return (dispatch: Dispatch) => {
		dispatch(actions.setLest(id));
	};
}

export function dokumenterSaveScroll(scrollPos: SaveScrollPosition) {
	return (dispatch: Dispatch) => {
		dispatch(actions.dokumenterSaveScroll(scrollPos));
	};
}

export function dokumenterDeleteScroll() {
	return (dispatch: Dispatch) => {
		dispatch(actions.dokumenterDeleteScroll());
	};
}
